import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import ChargingHabitGraph from '@di-shared/features/diag/ev-battery/ChargingHabitGraph';

interface EvBatteryChargingHabitBottomSheetProps {
  onExit: () => void;
  graphItems: {start: number; end: number; title: string; tooltipText: string}[];
  showCautionZone: boolean;
  avgMinSoc: number;
  avgMaxSoc: number;
}

export const DEFAULT_CAUTION_LEVEL = 10;
const BATTERY_AVERAGE_THRESHOLD = 20;

function EvBatteryChargingHabitBottomSheetEU({
  graphItems,
  showCautionZone,
  avgMinSoc,
  avgMaxSoc,
  onExit,
}: EvBatteryChargingHabitBottomSheetProps) {
  const {t} = useInferableTranslation();
  const titleSubMessage =
    avgMinSoc >= BATTERY_AVERAGE_THRESHOLD
      ? t('ctn_evb_charging_habits_btm_sht_result_eu', {N: avgMinSoc, M: avgMaxSoc})
      : t('ctn_evb_charging_habits_btm_sht_result_20under_eu', {N: avgMinSoc, M: avgMaxSoc});
  return (
    <div className="bottom_sheet bottom_sheet_battery">
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('ctn_evb_charging_habits_btm_sht_title_eu')}</h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('T10017')}
          onClick={onExit}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <strong className="bottom_sheet_title_sub">{titleSubMessage}</strong>
          <ChargingHabitGraph
            guideLines={[avgMinSoc, avgMaxSoc]}
            cautionLevel={DEFAULT_CAUTION_LEVEL}
            showCautionZone={showCautionZone}
          >
            {graphItems.map(({title, start, end, tooltipText}) => (
              <ChargingHabitGraph.Item
                key={title}
                start={start}
                end={end}
                title={title}
                tooltipText={tooltipText}
              />
            ))}
          </ChargingHabitGraph>
          {showCautionZone && (
            <div className="battery_guide_box">
              <strong className="title">
                <span className="ic ic_filled_notice" />
                {t('ctn_evb_charging_habits_btm_sht_warning_eu')}
              </strong>
              <p className="desc">{t('ctn_evb_charging_habits_btm_sht_warning_desc_eu')}</p>
            </div>
          )}

          <ul className="notice_list">
            <li className="notice_item">{t('ctn_evb_charging_habits_btm_sht_svc_desc1_eu')}</li>
            <li className="notice_item">{t('ctn_evb_charging_habits_btm_sht_svc_desc2_eu')}</li>
            <li className="notice_item">{t('ctn_evb_charging_habits_btm_sht_svc_desc3_eu')}</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default EvBatteryChargingHabitBottomSheetEU;
